import { cilColorBorder, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CContainer,
  CImage,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
  CToast,
  CToastBody,
  CToaster
} from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteFrame, getAllFramesTable } from 'src/services/Frames';

function FrameTables() {
  const [frames, setFrames] = useState([]);
  const [toast, addToast] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showEditConfirmModal, setShowEditConfirmModal] = useState(false);
  const [clickedRow, setClickedRow] = useState({});
  const [deleting, setDeleting] = useState(false);
  const navigate = useNavigate();

  const tableHeader = [
    { field: 'id', headerName: 'ID', width: '100' },
    { field: 'name', headerName: 'Name', width: '150' },
    { field: 'category', headerName: 'Category', width: '150' },
    { field: 'thumbnail_url', headerName: 'Thumbnail', width: '150' },
    { field: 'thumbnail_png_url', headerName: 'Thumbnail PNG', width: '150' },
    { field: 'image_url', headerName: 'Image URL', width: '100' },
    { field: 'used_count', headerName: 'Used Count', width: '100' },
    { field: 'image_count', headerName: 'Image Count', width: '100' },
    {
      field: 'actions',
      headerName: 'Actions',
      width: '150',
      renderCell: (params) => {
        return (
          <CContainer>
            <CRow xs={{ gutterX: 1 }}>
              <CCol>
                <CButton
                  onClick={(e) => {
                    setClickedRow(params);
                    setShowEditConfirmModal(true);
                  }}
                >
                  <CIcon icon={cilColorBorder} className="text-light" size="lg" />
                </CButton>
              </CCol>
              <CCol>
                <CButton
                  color="danger"
                  onClick={() => {
                    setClickedRow(params);
                    setShowConfirmModal(true);
                  }}
                >
                  <CIcon icon={cilTrash} className="text-light" size="lg" />
                </CButton>
              </CCol>
            </CRow>
          </CContainer>
        );
      }
    }
  ];

  async function fetchAllFrames() {
    await getAllFramesTable().then((response) => {
      const framesData = response.data;
      setFrames(framesData);
    });
  }

  async function handleDeleteFrame() {
    await deleteFrame({ id: clickedRow.id }).then(() => {
      fetchAllFrames();
      setDeleting(false);
    });
  }

  useEffect(() => {
    fetchAllFrames();
  }, []);

  useEffect(() => {
    if (deleting) {
      handleDeleteFrame();
    }
  }, [deleting]);

  const clipboardToast = (
    <CToast delay={1000}>
      <CToastBody>Copied to clipboard</CToastBody>
    </CToast>
  );

  function EditConfirmModal(props) {
    console.log(props.frame);
    return (
      <CModal visible={showEditConfirmModal} onClose={() => setShowEditConfirmModal(false)}>
        <CModalHeader>{`Edit ${props.frame?.row?.name}`}</CModalHeader>
        <CModalBody>
          <CImage
            align="center"
            fluid
            style={{
              maxHeight: '50vh'
            }}
            src={props.frame?.row?.thumbnail_url}
          />
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            onClick={() => {
              setShowEditConfirmModal(false);
            }}
          >
            Cancel
          </CButton>
          <CButton
            color="primary"
            onClick={() => {
              setShowEditConfirmModal(false);
              navigate('/adjust-frame', { state: { id: props.frame.id } });
            }}
          >
            Edit Frame
          </CButton>
          <CButton
            color="primary"
            onClick={() => {
              navigate('/frames-assignment-actions', { state: { frameId: props.frame.id } });
              setShowEditConfirmModal(false);
            }}
          >
            Assign Frame
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }

  function DeleteConfirmModal(props) {
    return (
      <CModal visible={showConfirmModal} onClose={() => setShowConfirmModal(false)}>
        <CModalHeader>{`Delete ${props.frame?.row?.name}`}</CModalHeader>
        <CModalBody>
          <p>Are you sure you want to delete this Frame?</p>
          <CImage
            align="center"
            fluid
            style={{
              maxHeight: '50vh'
            }}
            src={props.frame?.row?.thumbnail_url}
          />
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            onClick={() => {
              setShowConfirmModal(false);
            }}
          >
            Cancel
          </CButton>
          <CButton
            color="danger"
            className="text-light"
            onClick={() => {
              setDeleting(true);
              setShowConfirmModal(false);
            }}
          >
            Delete
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }

  return (
    <>
      <DeleteConfirmModal frame={clickedRow} />
      <EditConfirmModal frame={clickedRow} />
      <CCard>
        <CCardHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <label>Frame</label>
          <CButton
            onClick={(e) => {
              navigate('/adjust-frame');
            }}
          >
            Add Frame
          </CButton>
        </CCardHeader>
        <CCardBody>
          <DataGrid
            rows={frames}
            columns={tableHeader}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              },
              sorting: {
                sortModel: [{ field: 'id', sort: 'desc' }]
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            onCellDoubleClick={(e) => {
              // put content to clipboard
              navigator.clipboard.writeText(e.formattedValue);
              addToast(clipboardToast);
            }}
          />
        </CCardBody>
      </CCard>
      <CToaster push={toast} placement="bottom-center"></CToaster>
    </>
  );
}

export default FrameTables;
